import { render, staticRenderFns } from "./CreateComponent.vue?vue&type=template&id=22c00e70&scoped=true&lang=html"
import script from "./CreateComponent.vue?vue&type=script&lang=js"
export * from "./CreateComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateComponent.vue?vue&type=style&index=0&id=22c00e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c00e70",
  null
  
)

export default component.exports